import React, { useState, useEffect, useRef } from 'react';
import styles from "./InterStateContactDetails.module.scss";
import {AddressWrapped, Button, OrganisationWrapped, ErrorMsg} from "@onegovbugs/onegov-react-components";
import {
    isCompleted,
    isValidEmail,
    isAustralianPhoneNumberOrNull,
    isDayTimeNumberOrNull,
    validate,
    scrollToError,
    isSelected
  } from "../../../utils/Validation";
import Select from "react-select";
import { getAddresUrlPath } from '../../../utils/AddressHelper';

export const InterStateContactDetails = props => {
    
    const { continueButtonHandler, interStateData, addressTitle, interStateDecisionAppType, saveExitButtonHandler } = props;
    
    const [title, setTitle] = useState(interStateData.title ? interStateData.title : null);
    const [givenName, setGivenName] = useState(interStateData && interStateData.givenName ? interStateData.givenName : '');
    const [surname, setSurname] = useState(interStateData && interStateData.surname ? interStateData.surname : '');
    const [middleName, setMiddleName] = useState(interStateData && interStateData.middleName  ? interStateData.middleName : '');
    const [mobileNumber, setMobileNumber] = useState(interStateData && interStateData.mobileNumber ? interStateData.mobileNumber : '');
    const [daytimeTelephoneNumber, setDaytimeTelephoneNumber] = useState(interStateData && interStateData.daytimeTelephoneNumber ? interStateData.daytimeTelephoneNumber : '');
    const [emailAddress, setEmailAddress] = useState(interStateData && interStateData.emailAddress ? interStateData.emailAddress : '');
 
    const [address, setAddress] = useState(interStateData && interStateData.address ? interStateData.address : '');

    const componentRef = React.createRef();
    const [abn, setAbn] = useState(interStateData && interStateData.abn ? interStateData.abn : '');
    const [acn, setAcn] = useState(interStateData && interStateData.acn ? interStateData.acn : '');
    const [organisationIdType, setOrganisationIdType] = 
        useState(interStateData && interStateData.organisationIdType  ? interStateData.organisationIdType : '');
    const [organisationBusinessName, setOrganisationBusinessName] = 
        useState(interStateData && interStateData.organisationBusinessName  ? interStateData.organisationBusinessName : '');
    const testTradingName = { value: 'COMMONWEALTH AWARDS', label: 'COMMONWEALTH AWARDS' };
    const [selectedTradingName, setSelectedTradingName] = useState(testTradingName);
    
    const addressRef = useRef();
    const [showErrors, setShowErrors] = useState(false);
    const [isAddressValid, setIsAddressValid] = useState(true);
    const [isAddressValidating, setAddressValidating] = useState(false);
    const [warnPartialMatch, setWarnPartialMatch] = useState(false);
  
    const titleOptions = [
        {
          value: "mr",
          label: "Mr",
        },
        {
          value: "mrs",
          label: "Mrs",
        },
        {
          value: "miss",
          label: "Miss",
        },
        {
          value: "miss",
          label: "Ms",
        },
        {
            value: "sir",
            label: "Sir",
        },
        {
            value: "dr",
            label: "Dr",
        },
        {
            value: "prof",
            label: "Prof",
        },
        {
          value: "assocprof",
          label: "Assoc Prof",
        },
        {
          value: "rev",
          label: "Rev",
        },
        {
          value: "master",
          label: "Master",
        },
        {
          value: "father",
          label: "Father",
        },
        {
          value: "pastor",
          label: "Pastor",
        },
        {
          value: "sister",
          label: "Sister",
        },
      ];

    const [errors, setErrors] = useState({
        title: false,
        givenName: false,
        surname: false,
        daytimeTelephoneNumber: false,
        mobileNumber: false,
        emailAddress: false,
        address: false,
    });
  
    const validators = [
        {
            fieldName: "title",
            fieldValue: title,
            isValid: isSelected,
        },     
        {
            fieldName: 'givenName',
            fieldValue: givenName,
            isValid: isCompleted
        },
        {
            fieldName: 'surname',
            fieldValue: surname,
            isValid: isCompleted
        },
        {
            fieldName: 'daytimeTelephoneNumber',
            fieldValue: daytimeTelephoneNumber,
            isValid: v => isCompleted(v) && isDayTimeNumberOrNull(v),
        },                   
        {
            fieldName: 'mobileNumber',
            fieldValue: mobileNumber,
            isValid: isAustralianPhoneNumberOrNull
        },    
        {
            fieldName: 'emailAddress',
            fieldValue: emailAddress,
            isValid: isValidEmail
        },
        {
            fieldName: 'address',
            fieldValue: address,
            isValid: () => isAddressValid
        },
    ];

    useEffect(() => {
        validate(validators, setErrors);
      }, [title, givenName, surname, daytimeTelephoneNumber, mobileNumber, emailAddress, address]);
    return (

        <div className={styles.mainCont}>
        {               
            interStateDecisionAppType === 'Organisation' &&
            (        
                <React.Fragment>
                    <div className={"row"}>
                        <div className={'col-12'}>
                            {/* <OrganisationWrapped
                                regoType={organisationIdType}
                                setRegoType={setOrganisationIdType}
                                abnAcn={organisationIdNumber}
                                setAbnAcn={setOrganisationIdNumber}
                                businessName={organisationBusinessName}
                                setBusinessName={setOrganisationBusinessName}
                                DisableYINC={true}
                                hideTradingNameList={true}
                            /> */}
                            
                            <OrganisationWrapped
                                regoType={organisationIdType}
                                setRegoType={setOrganisationIdType}
                                abn={abn}
                                setAbn={setAbn}
                                acn={acn}
                                setAcn={setAcn}
                                businessName={organisationBusinessName}
                                setBusinessName={setOrganisationBusinessName}
                                // YINCDetails={YINCDetails}
                                // setYINCDetails={setYINCDetails}
                                // YINCName={YINCName}
                                // setYINCName={setYINCName}
                                // YINCTradingName={YINCTradingName}
                                // setYINCTradingName={setYINCTradingName}
                                baseURL={process.env.REACT_APP_BASE_URL}
                                disableYINC={true}
                                // disableABN={true}
                                // disableACN={true}
                                hideTradingNameList={true}
                                selectedTradingName={selectedTradingName}
                                setSelectedTradingName={setSelectedTradingName}
                                ref={componentRef}
                            />  
                        </div>
                    </div>

                    <div className={"row"}>
                        <div className={"col-12"}>
                            <h2>Business Contact Details</h2>
                        </div>
                    </div> 
                </React.Fragment>
            )    

        }   

            {/* <div className={"row"}>
                <div className={"col-12"}>
                    <h2>Contact Details</h2>
                </div>
            </div> */}

            {/* <div className={"row"}>
                <div className={"col-12 col-sm-6"}>
                    <label htmlFor={"title"}>
                        Title
                    </label>
                    <input
                    id={"title"}
                    className={styles.inputBox}
                    placeholder="Title"
                    value={title}
                    maxLength="100"
                    onChange={obj => {
                        setTitle(obj.target.value);
                        //setInterStateIndividual({ ...interStateIndividual, title: obj.target.value });
                    }}
                    />
                </div>
            </div> */}

            {/* <div className={"row"}>
                <div className={"col-12"}>
                    <h2>Contact Details</h2>
                </div>
            </div>  */}

            <div className={"row"}>

                <div className={"col-12 col-sm-6"}>
                    <label htmlFor="title">Title</label>
                    <Select
                        id={"inputTitle"}
                        value={title}
                        onChange={setTitle}
                        className={styles.select}
                        placeholder="Title"
                        options={titleOptions}
                    />
                    {errors.title && showErrors ? (
                        <ErrorMsg 
                            className={"ErrorMsg_error"}
                            type={"error"} 
                            description={"Title is required."} />
                    ) : null}
                </div>

                <div className={"col-12 col-sm-6"}>
                    <label htmlFor={"givenName"}>
                        First Name
                    </label>
                    <input
                        id={"givenName"}
                        className={styles.inputBox}
                        placeholder="First Name"
                        value={givenName}
                        maxLength="20"
                        onChange={obj => {
                            setGivenName(obj.target.value);
                            //setInterStateIndividual({ ...interStateIndividual, givenName: obj.target.value });
                        }}
                    />
                    {errors.givenName && showErrors ? (
                    <ErrorMsg 
                        className={"ErrorMsg_error"}
                        type={"error"}
                        description={"First Name is required."}
                    />
                    ) : null}                    
                </div>
            </div>


            <div className={"row"}>
                {/* <div className="col-12 col-sm-6">
                    <label htmlFor={"mobileNumber"}>Mobile number</label>
                    <input
                    id={"mobileNumber"}
                    className={styles.inputBox}
                    placeholder="Mobile number"
                    value={mobileNumber}
                    maxLength="20"
                    onChange={obj => {
                        setMobileNumber(obj.target.value);
                    }}
                    />
                </div> */}

                <div className="col-12 col-sm-6">
                    <label htmlFor={"surname"}>Last Name</label>
                    <input
                        id={"surname"}
                        className={styles.inputBox}
                        placeholder="Last Name"
                        value={surname}
                        maxLength="20"
                        onChange={obj => {
                            setSurname(obj.target.value);
                        }}
                    />
                    {errors.surname && showErrors ? (
                    <ErrorMsg 
                        className={"ErrorMsg_error"}
                        type={"error"}
                        description={"Last Name is required."}
                    />
                    ) : null}                       
                </div>                

                <div className="col-12 col-sm-6">
                    <label htmlFor={"middleName"}>Middle Name (Optional)</label>
                    <input
                    id={"middleName"}
                    className={styles.inputBox}
                    placeholder="Middle Name (Optional)"
                    value={middleName}
                    maxLength="20"
                    onChange={obj => {
                        setMiddleName(obj.target.value);
                    }}
                    />
                </div>

            </div>    

            <div className="row">

                <div className={"col-12 col-sm-6"}>
                    <label htmlFor={"daytimeTelephoneNumber"}>
                    Daytime Telephone Number
                    </label>
                    <input
                        id={"daytimeTelephoneNumber"}
                        className={styles.inputBox}
                        placeholder="Daytime Telephone Number"
                        value={daytimeTelephoneNumber}
                        maxLength="20"
                        onChange={obj => {
                            setDaytimeTelephoneNumber(obj.target.value);
                        }}
                    />
                    {(daytimeTelephoneNumber == null || daytimeTelephoneNumber == "") && errors.daytimeTelephoneNumber && showErrors ? (
                    <ErrorMsg 
                        className={"ErrorMsg_error"}
                        type={"error"}
                        description={"Daytime Telephone Number is required."}
                    />
                    ) : null}
                    {daytimeTelephoneNumber !== null && daytimeTelephoneNumber !== "" && errors.daytimeTelephoneNumber && showErrors ? (
                    <ErrorMsg 
                        className={"ErrorMsg_error"}
                        type={"error"}
                        description={"Daytime Telephone Number is invalid."}
                    />
                    ) : null}                    
                </div>                  

                <div className={"col-12 col-sm-6"}>
                    <label htmlFor={"mobileNumber"}>
                        Mobile Number (Optional)
                    </label>
                    <input
                    id={"mobileNumber"}
                    className={styles.inputBox}
                    placeholder="Mobile number"
                    value={mobileNumber}
                    maxLength="20"
                    onChange={obj => {
                        setMobileNumber(obj.target.value);
                    }}
                    />
                    {errors.mobileNumber && showErrors ?
                        <ErrorMsg
                        className={"ErrorMsg_error"}
                        type={"error"}
                        description={'Mobile Number is invalid.'}
                        />
                    : null}
                </div>   

            </div>
        
            {/* <div className={"row"}>
                <div className={"col-12"}>
                    <h2>Address</h2>
                </div>
            </div>  */}

            {/* <div className={"row"}>
                <div className={"col-12 col-sm-6"}>
                    <label htmlFor={"emailAddress"}>
                    Email address
                    </label>
                    <input
                    id={"emailAddress"}
                    className={styles.inputBox}
                    placeholder="Email address"
                    value={emailAddress}
                    maxLength="100"
                    onChange={obj => {
                        setEmailAddress(obj.target.value);
                    }}
                    />
                </div>
            </div> */}

            <div className='row'>
                <div className={"col-12 col-sm-6"}>
                    <label htmlFor={"emailAddress"}>
                    Email Address
                    </label>
                    <input
                        id={"emailAddress"}
                        className={styles.inputBox}
                        placeholder="Email Address"
                        value={emailAddress}
                        maxLength="100"
                        onChange={obj => {
                            setEmailAddress(obj.target.value);
                        }}
                    />
                    {errors.emailAddress && showErrors ?            
                        <ErrorMsg
                            className={"ErrorMsg_error"}
                            type={"error"}
                            description={'Email Address is required.'}
                        />
                    : null}                        
                </div>
            </div>

            <hr className={styles.hrLine} />

            <div className={"row"}>
                <div className={"col-12"}>
                {/* {
                    interStateDecisionAppType === 'Organisation' && 
                    <h2>Business Address</h2>
                }
                {
                    interStateDecisionAppType !== 'Organisation' && 
                    <h2>Address</h2>
                }                  */}

                    <h2>Postal Address</h2>
                </div>
            </div>                

            <div className='row'>
                <div className={`col-12`}>
                    {/* <AddressWrapped
                        autoValidate
                        label={addressTile}
                        baseUrl={process.env.REACT_APP_BASE_URL}
                        ref={addressRef}
                        onChange={(data) => setAddress(data.address)}
                        value={address ?? {}}
                        onValidationChange={setIsAddressValid}
                        onWarningChange={setWarnPartialMatch}
                        onLoading={setAddressValidating}
                    /> */}

                    {/* <AddressWrapped
                        autoValidate={false}
                        label={addressTitle}
                        placeholder={addressTitle}
                        baseUrl={process.env.REACT_APP_BASE_URL}
                        ref={addressRef}
                        onChange={(data) => setAddress(data.address)}
                        onDetailsRetrieved={(data) => console.log('onDetailsRetrieved', data)}
                        // onErrors={setErrors}
                        onValidating={setAddressValidating}
                        value={address ? {...address, internationalAddressEnabled: false} : {internationalAddressEnabled: false}}
                    />   */}

                    <AddressWrapped
                        international
                        autoValidate
                        label={null}
                        // placeholder={addressTitle}
                        baseUrl= { getAddresUrlPath() }
                        ref={addressRef}
                        onChange={(data) => setAddress(data.address)}
                        value={address ? {...address, internationalAddressEnabled: false} : {internationalAddressEnabled: false}}
                        onValidationChange={setIsAddressValid}
                        onWarningChange={setWarnPartialMatch}
                        onLoading={setAddressValidating}
                    />                    
                </div>
                {errors.address && showErrors ?
                    <div className={`col-12`}>
                    <ErrorMsg
                        className={"ErrorMsg_error"}
                        type={"error"}
                        description={'Please enter the address and select the right one from the dropdown or complete all the address fields.'}
                    />
                </div> : null}                    
            </div>

            <div className={`row ${styles.buttonCont}`}>
                <div className={`col-12`}>
                    <Button
                        disabled = {isAddressValidating}
                        onClick={() => {
                        
                        // const newInterStateDetails = 
                        // {
                        //     ...interStateData,
                        //     // title: title,
                        //     givenName: givenName,
                        //     surname: surname,
                        //     mobileNumber: mobileNumber,
                        //     daytimeTelephoneNumber: daytimeTelephoneNumber,
                        //     emailAddress: emailAddress
                        // }
                        var abnAcnResult = interStateDecisionAppType === "Organisation" ? componentRef.current.validate() : true;

                        if (validate(validators, setErrors) && abnAcnResult) {
                            const insterSateDetails ={
                                title, givenName, surname, middleName, mobileNumber,
                                daytimeTelephoneNumber, emailAddress, address,
                                organisationIdNumber: organisationIdType === "ABN" ? abn : acn, 
                                organisationIdType, abn, acn, organisationBusinessName
                            };
                            continueButtonHandler(insterSateDetails);
                            setShowErrors(false);
                        } else {
                            setShowErrors(true);
                            scrollToError();
                        }                        


                        // if (validate(validatorsOtherNames, setErrorsOtherNames) && validate(validators, setErrors)) {
                        //   props.history.push(`./employment`);
                        //   setShowErrors(false);
                        //   setShowErrorsOtherNames(false);
                        //   storeData();
                        // } else {
                        //   setShowErrors(true);
                        //   setShowErrorsOtherNames(true);
                        //   scrollToError();
                        // }
                        }}
                    >
                    Continue
                    </Button>

                    <Button
                        disabled = {isAddressValidating}
                        secondary
                        onClick={() => {
                            const insterSateDetails ={
                                title, givenName, surname, middleName, mobileNumber,
                                daytimeTelephoneNumber, emailAddress, address,
                                organisationIdType, abn, acn, organisationBusinessName
                            };                        
                            saveExitButtonHandler(insterSateDetails)
                        }}
                    >
                    Save & exit section
                    </Button>

                </div>
            </div>            

        </div>
         

    )
}